import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 flex flex-col justify-center items-center" }
const _hoisted_2 = ["readonly"]
const _hoisted_3 = ["readonly"]

import ServeButton from './ServeButton.vue'
import PointButton from './PointButton.vue'
import { IPair } from '@/interfaces'

export default /*#__PURE__*/_defineComponent({
  props: {
    pair: null,
    server: null,
    receiver: null,
    isLocked: { type: Boolean },
    pointBtnLocked: { type: Boolean }
  },
  emits: ['set-server', 'add-point'],
  setup(__props: any, { emit }) {

const props = __props as {
	pair: IPair
	server: number
	receiver: number
	isLocked: boolean
	pointBtnLocked: boolean
}




const setServer = (playerId: number) => emit('set-server', playerId, props.pair.id)
const addPoint = (id: number) => emit('add-point', id)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["bg-white px-3 py-2 rounded-md w-40", { 'bg-opacity-80': __props.isLocked }]),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.pair.playerA.name) = $event)),
        readonly: __props.isLocked
      }, null, 10, _hoisted_2), [
        [_vModelText, __props.pair.playerA.name]
      ]),
      _createVNode(ServeButton, {
        playerId: __props.pair.playerA.id,
        server: __props.server,
        receiver: __props.receiver,
        onSetServer: setServer
      }, null, 8, ["playerId", "server", "receiver"])
    ]),
    _createVNode(PointButton, {
      class: "my-5",
      id: __props.pair.id,
      locked: __props.pointBtnLocked,
      onAddPoint: addPoint
    }, null, 8, ["id", "locked"]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["bg-white px-3 py-2 rounded-md w-40", { 'bg-opacity-80': __props.isLocked }]),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.pair.playerB.name) = $event)),
        readonly: __props.isLocked
      }, null, 10, _hoisted_3), [
        [_vModelText, __props.pair.playerB.name]
      ]),
      _createVNode(ServeButton, {
        playerId: __props.pair.playerB.id,
        server: __props.server,
        receiver: __props.receiver,
        onSetServer: setServer
      }, null, 8, ["playerId", "server", "receiver"])
    ])
  ]))
}
}

})